import { Badge, Button, Card, Group, Text, Title } from '@mantine/core';
import Cost from '../Cost/Cost';
import GeneratorFeatures from '../GeneratorFeatures/GeneratorFeatures';
import classes from './GeneratorInfo.module.css';
import { By, Gap, Header, Id, Image, Points, Wrapper } from './GeneratorInfo.style';

export type GeneratorInfoProps = {
  generator: IGenerator;
  onOpenInPlayground: (id: string) => void;
};

export function GeneratorInfo(props: GeneratorInfoProps) {
  const { generator } = props;
  const { id, name, author, meta, imageUrl } = generator;
  const { category, categoryDescription, cost } = meta ?? {};

  function onOpenInPlayground() {
    props.onOpenInPlayground(id);
  }

  return (
    <Wrapper className='GeneratorInfo-wrapper pink-card' data-testid='GeneratorInfo-wrapper'>
      <Card withBorder radius='md' className={classes.card}>
        <Header>
          <Id>{id}</Id>
          <Title>{name}</Title>
          <By>by {author}</By>
        </Header>

        <Card.Section className={classes.imageSection}>
          <Image src={imageUrl} />
        </Card.Section>

        <Group justify='space-between' mt='md'>
          <div>
            <Text fw={500}>{category} collection</Text>
            <Text fz='xs' c='dimmed'>
              {categoryDescription}
            </Text>
          </div>
          <Badge variant='outline'>{category}</Badge>
        </Group>

        <Card.Section className={classes.section} mt='md'>
          <Text fz='sm' c='dimmed' className={classes.label}>
            Basic configuration
          </Text>

          <Group gap={8} mb={-8}>
            <GeneratorFeatures generator={generator} />
          </Group>
        </Card.Section>

        <Points>
          <Cost cost={cost} />
        </Points>

        <Card.Section className={classes.section}>
          <Group gap={30}>
            <Gap />
            <Button
              onClick={onOpenInPlayground}
              variant='gradient'
              gradient={{ deg: 45, from: 'pink', to: 'yellow' }}
            >
              Open in Playground
            </Button>
          </Group>
        </Card.Section>
      </Card>
    </Wrapper>
  );
}

export default GeneratorInfo;
